import { fetchWithAuth } from './auth';

export interface DocumentSummary {
  id: string;
  org_id: string;
  name: string | null;
  storage_path: string | null;
  size: number | null;
  type: string | null;
  related_id: string | null;
  related_type: string | null;
  uploaded_by: string | null;
  created_at: string;
}

export async function listDocuments(): Promise<DocumentSummary[]> {
  const r = await fetchWithAuth('/api/documents');
  if (!r.ok) throw new Error(`listDocuments failed: ${r.status}`);
  return (await r.json()) as DocumentSummary[];
}

export async function listDocumentsForJob(jobId: string): Promise<DocumentSummary[]> {
  const all = await listDocuments();
  return all
    .filter((d) => d.related_type === 'appraisal' && d.related_id === jobId)
    .sort((a, b) => (a.created_at < b.created_at ? 1 : -1));
}

export async function fetchDocumentBlob(id: string): Promise<Blob> {
  const r = await fetchWithAuth(`/api/documents/serve/${id}`);
  if (!r.ok) throw new Error(`fetchDocumentBlob failed: ${r.status}`);
  return await r.blob();
}

export function formatBytes(n: number | null | undefined): string {
  if (n == null) return '';
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}

const TYPE_COLORS: Record<string, string> = {
  'Carrier Estimate': 'bg-blue-500',
  'Storm Report': 'bg-amber-500',
  Assignment: 'bg-purple-500',
  'Contractor Estimate': 'bg-green-500',
  'Contractor Est.': 'bg-green-500',
  Measurement: 'bg-teal-500',
  'PA Estimate': 'bg-pink-500',
  'Lawyer Estimate': 'bg-red-500',
  'Lawyer Est.': 'bg-red-500',
  'Field Upload': 'bg-indigo-500',
};

export function typeChipColor(type: string | null | undefined): string {
  if (!type) return 'bg-gray-400';
  return TYPE_COLORS[type] ?? 'bg-gray-400';
}

/** Best-effort source badge. Field-uploaded docs will surface as FIELD once
 *  upload lands; everything else is EVA for now. */
export function docSource(d: DocumentSummary): 'EVA' | 'FIELD' {
  if ((d.type ?? '') === 'Field Upload') return 'FIELD';
  return 'EVA';
}
